<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
    created() {
        // 在页面刷新时将vuex里的信息保存到sessionStorage里
        window.addEventListener('beforeunload', () => {
            sessionStorage.setItem('CMSVuexState', JSON.stringify(this.$store.state));
        });
    }
};
</script>
<style lang="scss">
html, body {
  height: 100%;
  overflow: hidden;
}
#app {
  height: 100%;
  width: 100%;
}
</style>
